import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.dnah');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-dnah',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.dnah/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Sidebar tooltip for collapsed state */
.sidebar-tooltip {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 8px;
  padding: 4px 12px;
  background: #1c1917;
  color: #e7e5e4;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.sidebar-tooltip::before {
  content: "";
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 4px solid transparent;
  border-right-color: #1c1917;
}

.group:hover .sidebar-tooltip {
  opacity: 1;
}

/* Focus-visible styles for keyboard navigation */
:host ::ng-deep a:focus-visible,
:host ::ng-deep button:focus-visible,
:host ::ng-deep [routerLink]:focus-visible,
:host ::ng-deep [role=link]:focus-visible {
  outline: 2px solid #6C8DF6;
  outline-offset: 2px;
  border-radius: 4px;
}
:host ::ng-deep input:focus-visible,
:host ::ng-deep textarea:focus-visible,
:host ::ng-deep select:focus-visible {
  outline: 2px solid #6C8DF6;
  outline-offset: 0;
}`],
})
export class LayoutDnahComponent implements OnInit {
    public activeMenu: string = 'dashboard';
    public sidebarOpen: boolean = false;
    public sidebarCollapsed: boolean = false;
    public isDark: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.sidebarCollapsed = localStorage.getItem('dnah_sidebar') === 'collapsed';
        this.isDark = localStorage.getItem('dnah_theme') === 'dark';
        this.redirectIfBlocked();
        this.detectActiveMenu();
    }

    public currentRole() {
        const role = String(this.service.auth.session?.role || 'researcher').toLowerCase();
        if (['admin', 'administrator', 'superadmin', 'editor', 'manager', 'owner', '관리자'].includes(role)) return 'admin';
        if (['reviewer', '검수자'].includes(role)) return 'reviewer';
        if (['researcher', 'user', '연구자'].includes(role)) return 'researcher';
        return 'researcher';
    }

    public homeForRole(role: string = this.currentRole()) {
        if (role === 'admin') return '/collections';
        if (role === 'reviewer') return '/review';
        return '/chat';
    }

    public can(menu: string) {
        const role = this.currentRole();
        const menus: any = {
            dashboard: ['admin'],
            collections: ['admin'],
            graph: ['admin'],
            review: ['admin', 'reviewer'],
            chat: ['admin', 'researcher'],
            radar: ['admin', 'researcher'],
            workbench: ['admin', 'researcher'],
            studio: ['admin', 'researcher'],
            members: ['admin']
        };
        return (menus[menu] || []).includes(role);
    }

    public hasPlatformMenu() {
        return this.can('dashboard') || this.can('collections') || this.can('graph') || this.can('review');
    }

    public hasResearchMenu() {
        return this.can('chat') || this.can('radar') || this.can('workbench') || this.can('studio');
    }

    public pathAllowed(path: string = location.pathname) {
        const role = this.currentRole();
        if (path.startsWith('/mypage')) return true;
        if (role === 'admin') {
            return path === '/' || path.startsWith('/collections') || path.startsWith('/graph') || path.startsWith('/members') || path.startsWith('/review') || path.startsWith('/chat') || path.startsWith('/radar') || path.startsWith('/monitoring') || path.startsWith('/workbench') || path.startsWith('/compare') || path.startsWith('/studio') || path.startsWith('/reports');
        }
        if (role === 'reviewer') {
            return path.startsWith('/review');
        }
        return path.startsWith('/chat') || path.startsWith('/radar') || path.startsWith('/monitoring') || path.startsWith('/workbench') || path.startsWith('/compare') || path.startsWith('/studio') || path.startsWith('/reports');
    }

    public redirectIfBlocked() {
        if (this.pathAllowed()) return;
        const home = this.homeForRole();
        if (location.pathname !== home) location.href = home;
    }

    @HostListener('document:click')
    public clickout() {
        if (this.sidebarOpen) {
            this.sidebarOpen = false;
        }
    }

    public detectActiveMenu() {
        const path = location.pathname;
        if (path.startsWith('/collections')) this.activeMenu = 'collections';
        else if (path.startsWith('/radar') || path.startsWith('/monitoring')) this.activeMenu = 'radar';
        else if (path.startsWith('/workbench') || path.startsWith('/compare')) this.activeMenu = 'workbench';
        else if (path.startsWith('/studio') || path.startsWith('/reports')) this.activeMenu = 'studio';
        else if (path.startsWith('/graph')) this.activeMenu = 'graph';
        else if (path.startsWith('/review')) this.activeMenu = 'review';
        else if (path.startsWith('/chat')) this.activeMenu = 'chat';
        else if (path.startsWith('/members')) this.activeMenu = 'members';
        else this.activeMenu = 'dashboard';
    }

    public isActive(menu: string) {
        const path = location.pathname;
        if (menu === 'dashboard') return path === '/';
        if (menu === 'radar') return path.startsWith('/radar') || path.startsWith('/monitoring');
        if (menu === 'workbench') return path.startsWith('/workbench') || path.startsWith('/compare');
        if (menu === 'studio') return path.startsWith('/studio') || path.startsWith('/reports');
        return path.startsWith(`/${menu}`);
    }

    public menuClass(menu: string) {
        const collapsed = this.sidebarCollapsed;
        const active = this.isActive(menu);

        let cls = 'group relative flex items-center cursor-pointer transition-all duration-200 text-[13px] ';

        if (collapsed) {
            cls += 'justify-center py-2.5 ';
            if (active) {
                cls += 'mx-1.5 bg-white dark:bg-stone-900 text-stone-800 dark:text-stone-200 font-semibold rounded-xl';
            } else {
                cls += 'mx-1.5 rounded-lg text-stone-400 hover:bg-white/10 hover:text-stone-200';
            }
        } else {
            cls += 'gap-2.5 py-2.5 ';
            if (active) {
                cls += 'mx-2 px-3 bg-white dark:bg-stone-900 text-stone-800 dark:text-stone-200 font-semibold rounded-xl';
            } else {
                cls += 'mx-2 px-2 rounded-lg text-stone-400 hover:bg-white/10 hover:text-stone-200';
            }
        }

        return cls;
    }

    public async toggleSidebar() {
        this.sidebarCollapsed = !this.sidebarCollapsed;
        localStorage.setItem('dnah_sidebar', this.sidebarCollapsed ? 'collapsed' : 'expanded');
        await this.service.render();
    }

    public async toggleDark() {
        this.isDark = !this.isDark;
        localStorage.setItem('dnah_theme', this.isDark ? 'dark' : 'light');
        await this.service.render();
    }

    public async toggleMobileSidebar(event: Event) {
        event.stopPropagation();
        this.sidebarOpen = !this.sidebarOpen;
        await this.service.render();
    }

    public async closeMobileSidebar() {
        this.sidebarOpen = false;
        await this.service.render();
    }
}

export default LayoutDnahComponent;